import React, { useEffect, useState } from 'react';
import { Container, Box, Grid, Typography, Divider, Tab, Paper } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import  {getServicesClient} from '../../services/Services';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import TableServices from './TableServices';
import SpinnerLoad from '../../components/FormsUI/Spinner';
import { logout } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const Services = (props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [fullServices, setFullServices] = useState(null);
    const [error, setError] = useState(false);

    //to pagination
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);

    //to filter
    const [status, setStatus] = useState('all');
    const [services, setFilteredData] = useState(null);

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };
    const handleLimitChange = (event) => {
        setLimit(event.target.value);
        setPage(0);
    };
    const handleStatusChange = (event, newValue) => {
        setPage(0);
        setStatus(newValue);
    };

    const getDaysToExpiry = (activeservices) => {
        const serviceswithdays = activeservices;
        const today = new Date();

        activeservices.map((service) => {
            const expirydate = new Date(service.rawnextduedate);
            const difference = parseInt( (expirydate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24) );
            service["expirydays"] = difference;
        })

        return serviceswithdays;
    }

    useEffect(() => {

        const getServices = async () => {
            const serv = await getServicesClient();

            //console.log('servicios bd', serv);

            if (serv.error) {
                //error = true
                if(serv.message.status === 401){
                    logout();
                    navigate('/', {replace: true});
                }else{
                    setError(true);
                }
                
            } else {

                setFullServices(serv.services);

                const activeServices = serv.services.filter(s => s.status === 'Active');

                if (activeServices.length !== 0) {
                    setFilteredData(activeServices);
                    setStatus('Active');
                } else {
                    setFilteredData(serv.services);
                }

            }

        }

        getServices();

    }, [])

    useEffect(() => {
        //setFilteredData(status === 'all' ? fullServices : fullServices.filter(dt => dt.status === status))

        if (status === 'all') {
            setFilteredData(fullServices);
        }
        if (status === 'Active') {
            const filteredservice = fullServices.filter(dt => dt.status === 'Active' || dt.status === 'Completed');
            //setFilteredData(filteredservice);

            const newfilteredservice = getDaysToExpiry(filteredservice);
            setFilteredData(newfilteredservice);
        }
        if (status === 'Pending') {
            const filteredservice = fullServices.filter(dt => dt.status === 'Pending');
            setFilteredData(filteredservice);
        }
        if (status === 'Suspended') {
            const filteredservice = fullServices.filter(dt => dt.status === 'Suspended');
            setFilteredData(filteredservice);
        }
        if (status === 'Terminated') {
            const filteredservice = fullServices.filter(dt => dt.status === 'Terminated' || dt.status === 'Cancelled');
            setFilteredData(filteredservice);
        }

    }, [status])


    return (
        <>
            <Helmet>
                <title>{t('clientAreaTitle')}</title>
            </Helmet>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                }}
            >

                {services === null ?
                    <>
                        {error ?
                            <Container maxWidth="sm" variant='cont-nk'>

                                <Box sx={{ mb: 2, mt: 3 }}>
                                    <Typography
                                        color="textPrimary"
                                        variant="h2"
                                        align="center"
                                    >
                                        {t('sorry')}
                                    </Typography>

                                </Box>

                                <Box sx={{ pt: 1, pb: 2 }}>
                                    <Typography
                                        color="textSecondary"
                                        gutterBottom
                                        variant="body1"
                                        align="center"
                                    >
                                        {t('servicesLoadError')}
                                    </Typography>

                                </Box>

                            </Container>

                            :
                            <SpinnerLoad/>
                        }
                    </>

                    :
                    <Container maxWidth="lg" variant='cont-nk'>

                        <Box>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Box mt={3} mb={3} >
                                        <Typography variant='h4'>{t('myProductsAndServices')}</Typography>
                                        <Divider />
                                    </Box>
                                </Grid>

                                <Grid item xs={12}>
                                    <Box sx={{ width: '100%' }}>
                                        <TabContext value={status} component={Paper}>
                                            <Box sx={{ borderBottom: 1, borderColor: '#e8f2ff' }}>
                                                <TabList onChange={handleStatusChange} aria-label="service status tabs">
                                                    <Tab label={t('all')} value="all" variant='btnTab-nk' />
                                                    <Tab label={t('active')} value="Active" variant='btnTab-nk' />
                                                    <Tab label={t('pending')} value="Pending" variant='btnTab-nk' />
                                                    <Tab label={t('suspended')} value="Suspended" variant='btnTab-nk' />
                                                    <Tab label={t('terminated')} value="Terminated" variant='btnTab-nk' />
                                                </TabList>
                                            </Box>
                                            <TabPanel value="all">
                                                <TableServices services={services} page={page} limit={limit} handlePageChange={handlePageChange} handleLimitChange={handleLimitChange}></TableServices>
                                            </TabPanel>
                                            <TabPanel value="Active">
                                                <TableServices services={services} page={page} limit={limit} handlePageChange={handlePageChange} handleLimitChange={handleLimitChange}></TableServices>
                                            </TabPanel>
                                            <TabPanel value="Pending">
                                                <TableServices services={services} page={page} limit={limit} handlePageChange={handlePageChange} handleLimitChange={handleLimitChange}></TableServices>
                                            </TabPanel>
                                            <TabPanel value="Suspended">
                                                <TableServices services={services} page={page} limit={limit} handlePageChange={handlePageChange} handleLimitChange={handleLimitChange}></TableServices>
                                            </TabPanel>
                                            <TabPanel value="Terminated">
                                                <TableServices services={services} page={page} limit={limit} handlePageChange={handlePageChange} handleLimitChange={handleLimitChange}></TableServices>
                                            </TabPanel>
                                        </TabContext>

                                    </Box>

                                </Grid>
                            </Grid>

                        </Box>

                    </Container>
                }



            </Box>
        </>
    )




}

export default Services;